'use client'
import React from 'react';
import JobTypes from './job-types';
import FooterLogo from './footer-logo';
import { usePathname } from 'next/navigation';

const Footer = () => {
    const pathname = usePathname();
    // console.log("pathname", pathname);
    
    return (
        <>
            {(pathname !== "/terms-of-use" &&  pathname !== "/privacy-policy") && <JobTypes />}
            <FooterLogo />
        </>
    );
};

export default Footer;
